// How a user is drawn in a picker, in one place.
//
// ⚠️ IT EXISTS FOR THE KEY. MUI keys an Autocomplete option on its LABEL when
// no explicit key is given, and a person's name is not unique — five accounts
// on the live list are called "biswas Pranay Nepal". Duplicate React keys make
// the listbox drop and repeat rows as it re-renders on each keystroke, which
// reads as "it shows the same user over and over and the one I want is
// missing". Both pickers that take a user must render through this.
//
// ⚠️ AND FOR THE SECOND LINE. Even keyed correctly, five rows reading
// "biswas Pranay Nepal" are five identical choices — the operator cannot tell
// which one to grant access to. The mobile number and the id are what make them
// different, so they are shown, not just made searchable.

import React from 'react';
import { Box, Typography } from '@mui/material';
import { userLabel, userOptionKey } from '../../core/devices/deviceAdmin';

/** `renderOption` for any Autocomplete whose options are user rows. */
export const renderUserOption = (props, u) => {
  // ⚠️ The key must be spread LAST-ish but explicitly: MUI puts its own
  // label-derived key in `props`, and an explicit one after the spread wins.
  const { key, ...rest } = props;
  return (
    <li {...rest} key={userOptionKey(u)}>
      <Box>
        <Typography variant="body2" fontWeight={600}>{userLabel(u)}</Typography>
        <Typography variant="caption" color="text.secondary">
          {`${u.MobileNumber || 'no mobile'} · ID ${u.UserId}`}
        </Typography>
      </Box>
    </li>
  );
};

export default renderUserOption;
